import cntl from "cntl";
import Avatar from "./Avatar";
import PropTypes from "prop-types";
import { SIZE } from "../constants";
import { useMemo, useState } from "react";

const propTypes = {
  logo: PropTypes.object,
  picture: PropTypes.object,
  letters: PropTypes.string,
  size: PropTypes.oneOf([
    SIZE.xs,
    SIZE.sm,
    SIZE.md,
    SIZE.lg,
    SIZE.xl,
    SIZE["2xl"],
  ]),
};

function AvatarWithLogo({ size, letters, picture, logo }) {
  const [childSize, setChildSize] = useState("");

  const logoCn = () => cntl`
    rounded-full
    ${childSize}
  `;

  useMemo(() => {
    switch (size) {
      case SIZE.xs:
        setChildSize("w-2.5 h-2.5");
        break;
      case SIZE.sm:
        setChildSize("w-3 h-3");
        break;
      case SIZE.md:
        setChildSize("w-3.5 h-3.5");
        break;
      case SIZE["lg"]:
        setChildSize("w-4 h-4");
        break;
      case SIZE["xl"]:
        setChildSize("w-[1.125rem] h-[1.125rem]");
        break;
      case SIZE["2xl"]:
        setChildSize("w-5 h-5");
        break;
      default:
        setChildSize("w-2.5 h-2.5");
        break;
    }
  }, [size]);

  return (
    <Avatar size={size} letters={letters} picture={picture}>
      <div className={logoCn()}>{logo}</div>
    </Avatar>
  );
}

AvatarWithLogo.propTypes = propTypes;
export default AvatarWithLogo;
